import { Icon } from 'libs/growth-platform-brand-system-v2/src/components/Picto/Icon';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import React from 'react';

const AnchorLink = ({
  label,
  align = 'center',
}: {
  label: string;
  align?: 'left' | 'center';
}) => {
  return (
    <a
      href="#SectionComparisonTable"
      className={classNames(
        'z-10 flex items-center gap-[6px]',
        align === 'left' && 'justify-start',
        align === 'center' && 'justify-center',
      )}
    >
      {label}
      <Icon name="chevron" className="h-20 w-20 rotate-180" />
    </a>
  );
};

export default AnchorLink;
